import { render, staticRenderFns } from "./ShiftCustomPlanForm.vue?vue&type=template&id=2bcf4f4d&"
import script from "./ShiftCustomPlanForm.vue?vue&type=script&lang=ts&"
export * from "./ShiftCustomPlanForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports